/**
 * App-wide constants. Single source of truth for choices that appear in
 * multiple pages (filters, dropdowns, validation).
 */

export const GRADES = [
  "K",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
] as const;
export type Grade = (typeof GRADES)[number];

export const PAGE_SIZES = [10, 25, 50, 100] as const;
export type PageSize = (typeof PAGE_SIZES)[number];
export const DEFAULT_PAGE_SIZE: PageSize = 25;

export const DATE_FILTERS = ["today", "week", "month", "all"] as const;
export type DateFilter = (typeof DATE_FILTERS)[number];

export const SUBJECTS = ["math", "reading", "writing", "science", "social-studies"] as const;
export type Subject = (typeof SUBJECTS)[number];
